'use es6';

import { FINDER_OPTIONS_FETCH } from 'DesignData/actions/ActionTypes';
import { save } from 'DesignData/actions/finder/Options';
import { getSavedOptions } from 'DesignData/selectors/finder';
let currentOptions = null;
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();
  const options = getSavedOptions(state);

  if (currentOptions === null) {
    currentOptions = options;
  } else if (currentOptions !== options && result.type !== FINDER_OPTIONS_FETCH) {
    currentOptions = options;
    dispatch(save());
  }

  return result;
});